import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notifyUser } from "components/shared-components/AdvancareNotification";
import NewOrderService from "services/newOrderService";
import { formatValidationErrors } from "utils/ArrayUtils";

export const initialState = {
  list: [],
  creating: false,
  errorMessages: [],
  isOrderCreatedSuccessfully: false,
  showCashierForm: false,
};

export const createNewOrder = createAsyncThunk(
  "/createNewOrder",
  async (data, { rejectWithValue }) => {
    try {
      const response = await NewOrderService.create(data);
      const code = response.code;
      return {
        code: code,
        orders: response.data,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Error creating a order",
        }
      );
    }
  }
);

export const orderSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.fetching = !state.fetching;
    },
    setOrderCreatedSuccessfullyToFalse: (state, action) => {
      state.isOrderCreatedSuccessfully = false;
    },
    toggleFsNumberDialog: (state) => {
      state.showCashierForm = !state.showCashierForm;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createNewOrder.pending, (state) => {
        state.creating = true;
      })
      .addCase(createNewOrder.fulfilled, (state, action) => {
        state.creating = false;
        state.order = action.payload.orders;
        state.showNewForm = !state.showNewForm;
        state.isOrderCreatedSuccessfully = true;
        notifyUser("success", "bottomRight", "Order Created Successfully");
      })
      .addCase(createNewOrder.rejected, (state, action) => {
        if (action.payload.code == 422) {
          state.errorMessages = formatValidationErrors(action.payload.error);
        } else {
          // state.errorMessages = action.payload.error;
        }
        state.creating = false;
        notifyUser("error", "topRight", "Error creating order");
      });
  },
});

export const {
  showLoading,
  toggleFsNumberDialog,
  setOrderCreatedSuccessfullyToFalse,
} = orderSlice.actions;

export default orderSlice.reducer;
